import React from 'react';
import { Hero } from './components/Hero';
import { ProblemsSection } from './components/ProblemsSection';
import { ModulesSection } from './components/ModulesSection';
import { ReviewsSection } from './components/ReviewsSection';
import { BonusSection } from './components/BonusSection';
import { ComparisonSection } from './components/ComparisonSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { OfferSection } from './components/OfferSection';
import { ObjectionsSection } from './components/ObjectionsSection';
import { PurchasePopup } from './components/PurchasePopup';
import { BACKGROUND_IMAGE } from './lib/constants';
import { useMetaPixel } from './lib/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="relative min-h-full w-full bg-[#061a33]" data-id="element-0">
      {/* Blurred Spanish marina background */}
      <div className="fixed inset-0 -z-10" data-id="element-1">
        <img src={BACKGROUND_IMAGE} alt="" aria-hidden="true" className="h-full w-full scale-110 object-cover blur-[6px]" data-id="element-2" />
        <div className="absolute inset-0 bg-[#061a33]/85" data-id="element-3" />
      </div>

      <main className="relative mx-auto w-full max-w-md" data-id="element-4">
        <Hero data-id="element-5" />
        <ProblemsSection data-id="element-6" />
        <ModulesSection data-id="element-7" />
        <ReviewsSection data-id="element-8" />
        <BonusSection data-id="element-9" />
        <ComparisonSection data-id="element-10" />
        <TestimonialsSection data-id="element-11" />
        <OfferSection data-id="element-12" />
        <ObjectionsSection data-id="element-13" />
      </main>

      <PurchasePopup data-id="element-14" />
    </div>;
}